<sn-data-list #listElement reloadByQueryParams [fetchFn]="loadData">
  <sn-infinite-scroll windowScrollTarget>
    <sn-pull-to-refresh>
      <ng-template [ngIf]="list?.dataSource?.data?.length" [ngIfThen]="table"></ng-template>
      <ng-template
        [ngIf]="!list?.dataSource?.data?.length && list?.dataIsInited"
        [ngIfThen]="emptyList"
      ></ng-template>
    </sn-pull-to-refresh>
  </sn-infinite-scroll>

  <button
    mat-fab
    color="accent"
    [@snZoomIn]
    [@snzoomOut]
    [matTooltip]="'vehicleIntelligence.hotlist.updateAvailable' | t"
    matTooltipPosition="before"
    class="updateButton"
    (click)="updateHotlistData()"
    *ngIf="updateHotlistAvailable"
  >
    <sn-icon class="update-icon">update</sn-icon>
  </button>

  <button
    mat-fab
    color="accent"
    class="mat-add-button"
    [@snZoomIn]
    [@snZoomOut]
    [matTooltip]="'vehicleIntelligence.hotlist.createNew' | t"
    matTooltipPosition="before"
    (click)="addInternalHotlist()"
    *ngIf="canAddHotlist"
  >
    <sn-icon class="add-icon">add</sn-icon>
  </button>

  <ng-template #table>
    <fs-lpr-hotlists-table
      [columns]="columns"
      [items]="list?.dataSource?.data"
      [actions]="actions"
      [sort]="sort"
      [sortDirection]="sortDirection"
      (sortChange)="onSortChange($event)"
    >
    </fs-lpr-hotlists-table>
  </ng-template>

  <ng-template #emptyList>
    <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
      {{ 'common.noResultsMatchSearch' | t }}
    </sn-empty-state>
  </ng-template>
</sn-data-list>
